// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#safety-confirm-register[data-v-a6dcf5ca]{max-width:640px;margin-left:auto;margin-right:auto}#safety-confirm-register .note[data-v-a6dcf5ca]{margin:0 20px 20px 20px}#safety-confirm-register .cancel-btn[data-v-a6dcf5ca],#safety-confirm-register .register-btn[data-v-a6dcf5ca]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
